import type { CommentFieldValue } from "@/shared/components/comment-field/use-comment-field";
import type { FieldValue } from "@/shared/types/workflow/workflow-form.types";
import type { RichText } from "@spz/shared-domain";

/**
 * Returns the default value for a comment field
 */
export function getCommentDefaultValue(): FieldValue {
  return {
    content: {
      content: [],
      type: "doc",
    } as RichText,
    attachment: null,
  } as CommentFieldValue;
}
